export const getUserProfile = (state) => {
  return (state.user.user && state.user.user.profile) || {};
};
